import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon is-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass({ 'is-active': _ctx.currentView === this.text })
  }, [
    _createVNode(_component_router_link, {
      to: $props.uri,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentView( $props.text )))
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createElementVNode("i", {
            class: _normalizeClass('fas fa-' +  $props.img),
            "aria-hidden": "true"
          }, null, 2)
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ], 2))
}